import type { ReactNode } from 'react';
import { cn } from '@orgus/ui';

/** One labelled row in the design catalogue: the state on the left, the component on the right. */
export function Spec({ label, children, className }: { label: ReactNode; children: ReactNode; className?: string }) {
  return (
    <div className={cn('grid grid-cols-[132px_minmax(0,1fr)] items-start gap-4 border-b border-border-subtle py-3 last:border-b-0', className)}>
      <span className="pt-0.5 text-caption text-fg-subtle">{label}</span>
      <div className="flex min-w-0 flex-wrap items-center gap-2">{children}</div>
    </div>
  );
}

/** A small caption over a sample. */
export function Caption({ children }: { children: ReactNode }) {
  return <p className="mb-2 text-caption text-fg-subtle">{children}</p>;
}
